import script from "./report-onfig-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./report-onfig-form.vue?vue&type=script&lang=ts&setup=true"

import "./report-onfig-form.vue?vue&type=style&index=0&id=5a19fc26&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a19fc26"]])

export default __exports__